/**
 * Singapura ROND/RONS/RORC (Existing) — 폼값 → 템플릿 [[변수]] 변환.
 *   per-person 스코프 값은 패널이 이미 bare 키로 평탄화해 넘김. 여기선 조건값 pass-through + 날짜 ISO 유지.
 *   조건: nominee_dir_status / nominee_sh_status (unchanged/ceased/still) 는 백엔드 [[if …=="…"]] 가 소비.
 */
export function normalizeSingapuraRegistersForWord(input: Record<string, any>): Record<string, any> {
  // RORC Yes/No 회신은 체크박스(☒/☐) 조건부 — 백엔드 [[if is_still_controller == "yes"]]☒[[else]]☐[[endif]] 가
  //   is_still_controller/has_relevant_change 값을 직접 소비하므로 별도 가공 없이 pass-through.
  return { ...input };
}
